export default "/_next/static/chunks/fonts/Syne Regular-6d469b109e3df166818324d6089922d6.otf";